/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Stats_Scope_ScentingInputs */

const vi_warehouse_stats_scope_scenting = /** @type {(inputs: Warehouse_Stats_Scope_ScentingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô ướp hương`)
};

/**

* @param {Warehouse_Stats_Scope_ScentingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_stats_scope_scenting = /** @type {((inputs?: Warehouse_Stats_Scope_ScentingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Stats_Scope_ScentingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_stats_scope_scenting(inputs)
});